// Shared child picker for PlayFirst Parent pages that operate on a single
// child's data (Language Map, Settings, My Toys, etc.). Renders inline so
// each page shows the same UI at the top, and always persists selection
// via the central helper.
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { setActiveChildId } from './childSelection';

export default function ChildSwitcher({ items, value, onChange, className = '' }) {
  if (!Array.isArray(items) || items.length <= 1) return null;
  return (
    <div className={`inline-flex items-center gap-2 ${className}`} data-testid="child-switcher-wrap">
      <span className="text-xs uppercase tracking-wider text-[#7C6F9C] font-semibold">
        Viewing
      </span>
      <Select
        value={value || ''}
        onValueChange={(id) => {
          setActiveChildId(id);
          onChange(id);
        }}
      >
        <SelectTrigger
          className="h-9 rounded-full bg-white border-stone-200 text-sm min-w-[180px]"
          data-testid="child-switcher-trigger"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {items.map((c) => (
            <SelectItem key={c.id} value={c.id} data-testid={`child-switcher-option-${c.id}`}>
              {c.name || 'Unnamed'}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
